/* eslint-disable import/prefer-default-export */

export const getSidebarComments = state => state.sidebar.comments;
